{
  "platform.summary": "{tenants, plural, one {# klant} other {# klanten}} · {sites, plural, one {# site} other {# sites}}, waarvan {live} live",
  "platform.generated": "Cijfers van {when}. Alleen geaggregeerd; klantgegevens zie je via het beheer van de klant.",
  "platform.stats": "Kerncijfers van het platform",
  "platform.stat_properties": "Woningen beschikbaar",
  "platform.stat_properties_hint": "van {total} in beheer, alle klanten",
  "platform.stat_leads": "Aanvragen, 30 dagen",
  "platform.stat_leads_hint": "zonder spam",
  "platform.spark_leads": "Aanvragen per dag, laatste 30 dagen",
  "platform.stat_builds": "Builds, 30 dagen",
  "platform.stat_builds_hint": "mediaan {median} per build",
  "platform.spark_builds": "Buildtijd van de laatste builds",
  "platform.stat_ai": "AI-kosten deze maand",
  "platform.stat_ai_hint": "{tokens} tokens verwerkt",
  "platform.clients": "Klanten",
  "platform.clients_count": "{count, plural, one {# klant} other {# klanten}}",
  "platform.col_client": "Klant",
  "platform.col_properties": "Woningen",
  "platform.col_sites": "Sites en talen",
  "platform.col_leads": "Aanvragen 30 d",
  "platform.col_published": "Laatst gepubliceerd",
  "platform.col_ai": "AI deze maand",
  "platform.col_open": "Openen",
  "platform.plan.basis": "Basis",
  "platform.plan.connect": "Connect",
  "platform.plan.agency": "Agency",
  "platform.members": "{count, plural, one {# gebruiker} other {# gebruikers}}",
  "platform.sites_live": "{live} van {total} live",
  "platform.languages_live": "{count, plural, =0 {nog geen taal live} one {# taal live} other {# talen live}}",
  "platform.new_count": "{count} nieuw",
  "platform.not_published": "Nog niet gepubliceerd",
  "platform.build_took": "build {duration}",
  "platform.revision": "revisie {revision}",
  "platform.open_client": "Openen",
  "platform.no_membership": "Geen toegang",
  "platform.no_clients": "Nog geen klanten",
  "platform.leads": "Aanvragen",
  "platform.leads_chart": "Aanvragen per week en kanaal, laatste 12 weken",
  "platform.week_of": "Week van {date}",
  "platform.channel_website": "Website",
  "platform.channel_portal": "Portaal",
  "platform.channel_other": "Overig",
  "platform.conversion": "Conversie (90 d)",
  "platform.conversion_hint": "{won} gewonnen van {closed} afgerond",
  "platform.conversion_none": "Nog geen aanvraag gewonnen of verloren",
  "platform.first_response": "Eerste reactie",
  "platform.first_response_hint": "mediaan per klant, 90 dagen",
  "platform.first_response_none": "Nog geen reactietijden vastgelegd",
  "platform.funnel": "Aanvragen per status, 90 dagen",
  "platform.funnel_empty": "Geen aanvragen in de afgelopen 90 dagen.",
  "platform.spam_filtered": "{count, plural, one {# bericht} other {# berichten}} als spam herkend en niet meegeteld.",
  "platform.properties": "Woningen per klant",
  "platform.properties_count": "{count, plural, one {# woning} other {# woningen}}",
  "platform.seg_available": "Beschikbaar",
  "platform.seg_ready": "Klaar, niet beschikbaar",
  "platform.seg_draft": "Concept",
  "platform.builds": "Publicaties en builds",
  "platform.builds_30": "Builds 30 d",
  "platform.builds_median": "Mediaan",
  "platform.builds_p90": "P90",
  "platform.builds_failed": "Mislukt",
  "platform.builds_chart": "Buildtijd in seconden per site (productie)",
  "platform.builds_stuck_title": "{count, plural, one {# build staat} other {# builds staan}} langer dan 30 minuten op bezig",
  "platform.builds_stuck_body": "Kijk bij de klant onder Website naar de buildlog; de worker heeft hem mogelijk niet afgerond.",
  "platform.no_builds": "Nog geen builds",
  "platform.never_built": "Nog nooit gebouwd",
  "platform.quality": "SEO en prestaties",
  "platform.all_sites": "Alle sites",
  "platform.measured_mobile": "mobiel, gemeten {when}",
  "platform.no_measurement": "Nog geen geslaagde meting",
  "platform.no_measurement_hint": "Meet de site met Nu meten, of draai de opdracht hieronder in de projectmap.",
  "platform.no_measurement_unpublished": "Deze site heeft nog geen publicatie in BRES. Een meting slaagt alleen als het adres al een pagina geeft.",
  "platform.q_performance": "Prestaties",
  "platform.q_performance_short": "Prest.",
  "platform.q_accessibility": "Toegankelijkheid",
  "platform.q_accessibility_short": "Toeg.",
  "platform.q_best_practices": "Praktijken",
  "platform.q_best_practices_short": "Prakt.",
  "platform.q_seo": "SEO",
  "platform.locales": "Talen en vertaalstatus",
  "platform.locales_for": "Vertaalstatus van woningteksten voor {site}",
  "platform.loc_approved": "Goedgekeurd",
  "platform.loc_review": "In review",
  "platform.loc_stale": "Verouderd",
  "platform.loc_missing": "Ontbreekt",
  "platform.ai": "AI-verbruik",
  "platform.ai_no_budget": "{spent}, geen budget ingesteld",
  "platform.ai_tokens_chart": "Tokens per maand en klant",
  "platform.ai_no_usage": "Geen AI-verbruik in de afgelopen zes maanden.",
  "platform.ai_jobs": "{count, plural, one {# AI-taak} other {# AI-taken}} in 30 dagen, {blocked} geblokkeerd of mislukt",
  "platform.channels": "Portalen",
  "platform.listings": "{count, plural, one {# listing} other {# listings}}",
  "platform.listings_accepted": "{count} geaccepteerd",
  "platform.listings_rejected": "{count} afgewezen",
  "platform.no_channels": "Nog geen portaalkoppelingen",
  "platform.analytics": "Google Analytics en Search Console",
  "platform.link_todo": "nog te koppelen",
  "platform.link_awaiting": "ingesteld, wacht op eerste ophaalronde",
  "platform.link_connected": "gekoppeld",
  "platform.credentials_missing": "Nog geen serviceaccount ingesteld. Zonder serviceaccount haalt BRES geen bezoekers- of zoekcijfers op en toont het die ook niet.",
  "platform.credentials_present": "Serviceaccount ingesteld. Cijfers verschijnen na de eerste ophaalronde.",
  "platform.sites_title": "Sites en SEO",
  "platform.sites_count": "{count, plural, one {# site} other {# sites}}",
  "platform.form_label": "Apparaat",
  "platform.form_mobile": "Mobiel",
  "platform.form_desktop": "Desktop",
  "platform.measure_title": "Lokaal gemeten met Lighthouse",
  "platform.measure_body": "Nu meten zet een meting klaar voor de worker: Lighthouse draait lokaal in een eigen headless Chromium tegen het adres van de site, mobiel en desktop, en bewaart de uitkomst. Zonder worker kan het ook met deze opdracht in de projectmap.",
  "platform.no_sites": "Nog geen sites",
  "platform.open_site": "{site} openen in een nieuw tabblad",
  "platform.view_site": "Site bekijken",
  "platform.history_for": "Prestaties en SEO van {site} door de tijd",
  "platform.history": "Scores door de tijd",
  "platform.history_one": "Na een tweede meting zie je hier de lijn door de tijd.",
  "platform.measured_at": "Gemeten {when}",
  "platform.details": "Details",
  "platform.scores": "Scores",
  "platform.vital_lcp": "Largest Contentful Paint",
  "platform.vital_fcp": "First Contentful Paint",
  "platform.vital_tbt": "Total Blocking Time",
  "platform.vital_cls": "Cumulative Layout Shift",
  "platform.vital_si": "Speed Index",
  "platform.vital_ttfb": "Reactietijd van de server",
  "platform.tool_line": "Lighthouse {version} · {url} · {when}",
  "platform.last_run_failed": "Laatste meting mislukt ({when})",
  "platform.issues": "Wat de score drukt",
  "platform.issues_none": "Geen afgekeurde onderdelen in de laatste meting",
  "platform.cat.performance": "Prestaties",
  "platform.cat.accessibility": "Toegankelijkheid",
  "platform.cat.best-practices": "Praktijken",
  "platform.cat.seo": "SEO",
  "platform.runs": "Alle metingen",
  "platform.runs_count": "{count, plural, one {# meting} other {# metingen}}",
  "platform.no_runs": "Nog geen metingen",
  "platform.col_when": "Gemeten",
  "platform.col_status": "Resultaat",
  "platform.col_duration": "Duur",
  "platform.run_ok": "Geslaagd",
  "platform.run_failed": "Mislukt",
  "platform.analytics_note": "BRES leest alleen. Zonder serviceaccount, eigendom en toegang in Google blijft een koppeling op nog te koppelen; er worden geen cijfers geschat of ingevuld.",
  "platform.evidence_line": "{level} · gecontroleerd op {date}",
  "platform.link_status.not_configured": "Nog te koppelen",
  "platform.link_status.awaiting_credentials": "Wacht op serviceaccount",
  "platform.link_status.awaiting_first_sync": "Wacht op eerste ophaalronde",
  "platform.link_status.connected": "Gekoppeld",
  "platform.link_status.error": "Ophalen mislukt",
  "platform.step_credentials": "Serviceaccount in BRES_GOOGLE_SERVICE_ACCOUNT_FILE",
  "platform.step_credentials_ok": "Serviceaccount {email}",
  "platform.step_ref_ga": "GA4 property-ID van deze site",
  "platform.step_ref_gsc": "Search Console-eigendom van deze site",
  "platform.step_access": "Serviceaccount heeft leestoegang in Google (blijkt bij de eerste ophaalronde)",
  "platform.ref_label_ga": "GA4 property-ID",
  "platform.ref_label_gsc": "Search Console-eigendom",
  "platform.ref_hint_ga": "Alleen cijfers, te vinden onder Beheer > Property-instellingen.",
  "platform.ref_hint_gsc": "sc-domain:domein.es of een URL-prefix zoals https://www.domein.es/",
  "platform.ref_invalid_google_analytics_4": "Een GA4 property-ID bestaat uit 6 tot 12 cijfers.",
  "platform.ref_invalid_google_search_console": "Gebruik sc-domain:domein.es of een https-adres dat eindigt op /.",
  "platform.ref_save": "Opslaan",
  "platform.ref_clear": "Wissen",
  "platform.link_saved": "{name} ingesteld",
  "platform.link_cleared": "{name} gewist",
  "platform.sync_command": "Cijfers ophalen",
  "platform.last_sync": "Laatst opgehaald {when}",
  "platform.no_access_title": "Alleen voor platformbeheerders",
  "platform.no_access_body": "Dit deel van BRES is voor het BRES-team. Je eigen organisatie beheer je via het menu links.",
  "platform.leads_90": "Aanvragen, 90 dagen",
  "platform.site_info": "Site",
  "platform.client": "Klant",
  "platform.live": "Live",
  "platform.live_line": "revisie {revision}, live {when}",
  "platform.hosts": "Adressen",
  "platform.host_kind.production": "productie",
  "platform.host_kind.preview": "preview",
  "platform.host_kind.local": "lokaal",
  "platform.languages": "Talen",
  "platform.open_workspace": "Beheer van de klant openen",
  "platform.no_membership_hint": "Je hebt nog geen toegang tot deze klant. Neem tijdelijke ondersteuningstoegang om de klantgegevens te beheren.",
  "platform.step_credentials_invalid": "Het sleutelbestand in BRES_GOOGLE_SERVICE_ACCOUNT_FILE is geen geldig serviceaccount",
  "platform.measure_now": "Nu meten",
  "platform.measure_waiting": "Wacht op worker",
  "platform.measuring": "Bezig met meten",
  "platform.measure_requested": "Meting aangevraagd",
  "platform.measure_requested_body": "Lighthouse meet mobiel en desktop zodra de worker de taak oppakt.",
  "platform.measure_queued_title": "Meting aangevraagd om {time}",
  "platform.measure_queued_body": "De worker pakt de taak zo op; deze pagina ververst vanzelf.",
  "platform.measure_stuck_title": "Meting staat sinds {time} klaar maar is nog niet opgepakt",
  "platform.measure_stuck_body": "Er lijkt geen worker te draaien. Start de lokale omgeving met pnpm dev; de meting gaat dan alsnog door.",
  "platform.measure_running_title": "Lighthouse meet nu mobiel en desktop",
  "platform.measure_running_body": "Dit duurt meestal een halve minuut. De scores verschijnen hier vanzelf.",
  "platform.measure_failed_title": "Meting kon niet worden uitgevoerd ({time})",
  "platform.measure_done": "Meting van {site} klaar",
  "platform.measure_done_body": "Mobiel: prestaties {performance}, SEO {seo}.",
  "platform.measure_done_failed_runs": "Lighthouse kon de site niet goed laden; de reden staat bij de metingen.",
  "platform.measure_failed": "Meting van {site} mislukt",
  "platform.at_time": "om {time}",
  "platform.on_date": "op {date}",
  "platform.demo": "Demo",
  "platform.bres.no_member_title": "Geen toegang tot de BRES-omgeving",
  "platform.bres.no_member_body": "De blog en chatbot van de BRES-site staan in de organisatie BRES (eigen omgeving). Vraag een eigenaar om je toe te voegen.",
  "platform.ai.title": "AI-opties per klant",
  "platform.ai.lead": "AI is een betaalde uitbreiding. Zet functies per klant of per site aan, spreek een maandplafond af en handel verzoeken af.",
  "platform.ai.test_title": "Lokaal draait de testadapter",
  "platform.ai.test_body": "Er is geen taalmodel aangesloten: concepten en antwoorden komen van een herkenbare testadapter en kosten niets. Een echte provider vraagt een sleutel en budgetakkoord.",
  "platform.ai.requests_title": "{count, plural, one {Eén verzoek van een klant} other {# verzoeken van klanten}}",
  "platform.ai.request_line": "{tenant} vraagt om {feature}",
  "platform.ai.enable": "Aanzetten",
  "platform.ai.disable": "Uitzetten",
  "platform.ai.close_request": "Afhandelen",
  "platform.ai.sites": "{count, plural, one {# site} other {# sites}}",
  "platform.ai.month": "AI-kosten deze maand",
  "platform.ai.of_cap": "Verbruik van het plafond",
  "platform.ai.cap_value": "van {cap}",
  "platform.ai.no_cap": "Geen plafond afgesproken",
  "platform.ai.cap_set": "Plafond {cap} per maand",
  "platform.ai.cap_none": "geen plafond",
  "platform.ai.own_budget": "eigen budget klant {budget}",
  "platform.ai.cap_edit": "Plafond",
  "platform.ai.cap_title": "Maandplafond voor {tenant}",
  "platform.ai.cap_body": "Het plafond geldt altijd als harde grens, ook als de klant zelf een hoger budget instelt.",
  "platform.ai.cap_amount": "Plafond per maand",
  "platform.ai.cap_clear": "Plafond wissen",
  "platform.ai.cap_saved": "Plafond opgeslagen",
  "platform.ai.features_label": "AI-functies van {tenant}",
  "platform.ai.usage": "{count, plural, one {# taak} other {# taken}} · {cost}",
  "platform.ai.no_usage": "Nog niet gebruikt deze maand",
  "platform.ai.changed_by": "{name}, {date}",
  "platform.ai.by_migration": "Overgenomen (bestond al)",
  "platform.ai.by_seed": "Demo-abonnement",
  "platform.ai.never": "Nooit aangezet",
  "platform.ai.confirm_on": "{feature} aanzetten?",
  "platform.ai.confirm_off": "{feature} uitzetten?",
  "platform.ai.confirm_on_body": "Voor {target}. De klant kan de functie daarna gebruiken; de kosten tellen mee in het plafond.",
  "platform.ai.confirm_off_body": "Voor {target}. De API weigert de functie meteen; na een nieuwe publicatie toont de site haar niet meer.",
  "platform.ai.note": "Notitie",
  "platform.ai.note_hint": "Bijvoorbeeld de reden of het contract. Komt in de auditlog.",
  "platform.ai.republish": "Site meteen opnieuw publiceren, zodat blog of chatbot verschijnt of verdwijnt",
  "platform.ai.enabled_toast": "Functie aangezet",
  "platform.ai.disabled_toast": "Functie uitgezet",
  "platform.ai.republished": "Nieuwe publicatie r{revision} gestart.",
  "platform.ai.history_title": "Wijzigingen",
  "platform.ai.history_lead": "Wie wat wanneer wijzigde, uit de platformaudit.",
  "platform.ai.history_empty": "Nog geen wijzigingen",
  "platform.ai.h_on": "zette {feature} aan voor {target}",
  "platform.ai.h_off": "zette {feature} uit voor {target}",
  "platform.ai.h_cap": "zette het plafond van {tenant} op {cap}",
  "platform.ai.h_request": "handelde een verzoek af",
  "platform.ai.on": "Aan",
  "platform.ai.off": "Uit",
  "platform.rep.title": "Reviews",
  "platform.rep.lead": "Module per klant en site, verzoeken, gezondheid per dienst en de status van de BRES-apps. Alleen aantallen, nooit reviewtekst of namen.",
  "platform.rep.requests": "{count, plural, one {# verzoek} other {# verzoeken}}",
  "platform.rep.request_close": "Sluiten zonder aanzetten",
  "platform.rep.request_grant": "{level} aanzetten",
  "platform.rep.scope_tenant": "Hele klant",
  "platform.rep.health": "Gezondheid",
  "platform.rep.tenants_with_reviews": "Klanten met gepubliceerde reviews",
  "platform.rep.syncs": "Synchronisaties, 7 dagen",
  "platform.rep.syncs_failed": "{count, plural, =0 {geen mislukt} one {# mislukt} other {# mislukt}}",
  "platform.rep.reply_time": "Mediane antwoordtijd, 90 dagen",
  "platform.rep.hours": "{n} uur",
  "platform.rep.none": "Nog geen",
  "platform.rep.invites": "Ingediend van verstuurd",
  "platform.rep.invites_meta": "Uitnodigingen, 30 dagen",
  "platform.rep.reports": "Open meldingen",
  "platform.rep.aggregates_only": "Demotenants tellen niet mee in reviews per week en klanten met reviews.",
  "platform.rep.services": "Diensten en BRES-apps",
  "platform.rep.oauth_ready": "OAuth-app ingesteld",
  "platform.rep.oauth_missing": "OAuth-app ontbreekt",
  "platform.rep.conn_count": "{count} {status}",
  "platform.rep.modules": "Module per klant en site",
  "platform.rep.modules_lead": "Basis zit in elk websitepakket. Pro (alle bronnen, automatische uitnodigingen, inzicht) zet je per site aan. Elke wijziging staat in de platformaudit en bij de klant.",
  "platform.rep.site_level": "Niveau voor {site}",
  "platform.rep.inherited": "volgt de klant",
  "platform.rep.demo": "Demo",
  "platform.rep.no_tenants": "Nog geen klanten",
  "platform.rep.level.off": "Uit",
  "platform.rep.level.basis": "Basis",
  "platform.rep.level.pro": "Pro",
  "platform.rep.change_title": "Reviews voor {tenant}: {scope}",
  "platform.rep.level_body.off": "Reviews verdwijnen bij de volgende publicatie van de site. Koppelingen en gegevens blijven tot het einde van de bewaartermijn.",
  "platform.rep.level_body.basis": "Eigen reviews, Google en Kiyoh, handmatig uitnodigen.",
  "platform.rep.level_body.pro": "Alle bronnen, automatische uitnodigingen, channel managers en inzicht.",
  "platform.rep.level_confirm.off": "Uitzetten",
  "platform.rep.level_confirm.basis": "Basis aanzetten",
  "platform.rep.level_confirm.pro": "Pro aanzetten",
  "platform.rep.note": "Notitie voor de audit",
  "platform.rep.republish": "De site(s) direct opnieuw publiceren",
  "platform.rep.saved": "Module bijgewerkt",
  "platform.rep.evidence.candidate": "Kandidaat",
  "platform.rep.evidence.awaiting_contract": "Wacht op contract",
  "platform.rep.evidence.documented": "Gedocumenteerd",
  "platform.rep.evidence.implemented": "Gebouwd",
  "platform.rep.evidence.contract_tested": "Contract getest",
  "platform.rep.evidence.sandbox_accepted": "Getest bij de dienst",
  "platform.rep.evidence.production_enabled": "Live"
}
